const COUNTRIES = {
  ad: { id: "ad", name: "Andorra" },
  ae: { id: "ae", name: "United Arab Emirates" },
  af: { id: "af", name: "Afghanistan" },
  ag: { id: "ag", name: "Antigua and Barbuda" },
  al: { id: "al", name: "Albania" },
  am: { id: "am", name: "Armenia" },
  ana: { id: "ana", name: "Anac" },
  ao: { id: "ao", name: "Angola" },
  aq: { id: "aq", name: "Antarctica" },
  ar: { id: "ar", name: "Argentina" },
  as: { id: "as", name: "American Samoa" },
  at: { id: "at", name: "Austria" },
  au: { id: "au", name: "Australia" },
  aw: { id: "aw", name: "Aruba" },
  ax: { id: "ax", name: "Åland Islands" },
  az: { id: "az", name: "Azerbaijan" },
  ba: { id: "ba", name: "Bosnia and Herzegovina" },
  bb: { id: "bb", name: "Barbados" },
  bd: { id: "bd", name: "Bangladesh" },
  be: { id: "be", name: "Belgium" },
  bf: { id: "bf", name: "Burkina Faso" },
  bg: { id: "bg", name: "Bulgaria" },
  bh: { id: "bh", name: "Bahrain" },
  bi: { id: "bi", name: "Burundi" },
  bj: { id: "bj", name: "Benin" },
  bl: { id: "bl", name: "Saint Barthélemy" },
  bm: { id: "bm", name: "Bermuda" },
  bn: { id: "bn", name: "Brunei" },
  bo: { id: "bo", name: "Bolivia" },
  bq: { id: "bq", name: "Caribbean Netherlands" },
  br: { id: "br", name: "Brazil" },
  bs: { id: "bs", name: "Bahamas" },
  bt: { id: "bt", name: "Bhutan" },
  bv: { id: "bv", name: "Bouvet Island" },
  bw: { id: "bw", name: "Botswana" },
  by: { id: "by", name: "Belarus" },
  bz: { id: "bz", name: "Belize" },
  ca: { id: "ca", name: "Canada" },
  cc: { id: "cc", name: "Cocos (Keeling) Islands" },
  cd: { id: "cd", name: "Democratic Republic of the Congo" },
  cefta: { id: "cefta", name: "Central European Free Trade Agreement" },
  cf: { id: "cf", name: "Central African Republic" },
  cg: { id: "cg", name: "Republic of the Congo" },
  ch: { id: "ch", name: "Switzerland" },
  ci: { id: "ci", name: "Côte d'Ivoire" },
  ck: { id: "ck", name: "Cook Islands" },
  cl: { id: "cl", name: "Chile" },
  cm: { id: "cm", name: "Cameroon" },
  cn: { id: "cn", name: "China" },
  co: { id: "co", name: "Colombia" },
  cp: { id: "cp", name: "Clipperton Island" },
  cr: { id: "cr", name: "Costa Rica" },
  cu: { id: "cu", name: "Cuba" },
  cv: { id: "cv", name: "Cape Verde" },
  cw: { id: "cw", name: "Curaçao" },
  cx: { id: "cx", name: "Christmas Island" },
  cy: { id: "cy", name: "Cyprus" },
  cz: { id: "cz", name: "Czech Republic" },
  de: { id: "de", name: "Germany" },
  dg: { id: "dg", name: "Diego Garcia" },
  dj: { id: "dj", name: "Djibouti" },
  dk: { id: "dk", name: "Denmark" },
  dm: { id: "dm", name: "Dominica" },
  do: { id: "do", name: "Dominican Republic" },
  dz: { id: "dz", name: "Algeria" },
  ea: { id: "ea", name: "Ceuta & Melilla" },
  ec: { id: "ec", name: "Ecuador" },
  ee: { id: "ee", name: "Estonia" },
  eg: { id: "eg", name: "Egypt" },
  eh: { id: "eh", name: "Western Sahara" },
  er: { id: "er", name: "Eritrea" },
  "es-ct": { id: "es-ct", name: "Catalonia" },
  "es-ga": { id: "es-ga", name: "Galicia" },
  es: { id: "es", name: "Spain" },
  et: { id: "et", name: "Ethiopia" },
  eu: { id: "eu", name: "European Union" },
  fi: { id: "fi", name: "Finland" },
  fj: { id: "fj", name: "Fiji" },
  fk: { id: "fk", name: "Falkland Islands" },
  fm: { id: "fm", name: "Micronesia" },
  fo: { id: "fo", name: "Faroe Islands" },
  fr: { id: "fr", name: "France" },
  ga: { id: "ga", name: "Gabon" },
  "gb-eng": { id: "gb-eng", name: "England" },
  "gb-nir": { id: "gb-nir", name: "Northern Ireland" },
  "gb-sct": { id: "gb-sct", name: "Scotland" },
  "gb-wls": { id: "gb-wls", name: "Wales" },
  gb: { id: "gb", name: "United Kingdom" },
  gd: { id: "gd", name: "Grenada" },
  ge: { id: "ge", name: "Georgia" },
  gf: { id: "gf", name: "French Guiana" },
  gg: { id: "gg", name: "Guernsey" },
  gh: { id: "gh", name: "Ghana" },
  gi: { id: "gi", name: "Gibraltar" },
  gl: { id: "gl", name: "Greenland" },
  gm: { id: "gm", name: "Gambia" },
  gn: { id: "gn", name: "Guinea" },
  gp: { id: "gp", name: "Guadeloupe" },
  gq: { id: "gq", name: "Equatorial Guinea" },
  gr: { id: "gr", name: "Greece" },
  gs: { id: "gs", name: "South Georgia & South Sandwich Islands" },
  gt: { id: "gt", name: "Guatemala" },
  gu: { id: "gu", name: "Guam" },
  gw: { id: "gw", name: "Guinea-Bissau" },
  gy: { id: "gy", name: "Guyana" },
  hk: { id: "hk", name: "Hong Kong" },
  hm: { id: "hm", name: "Heard & McDonald Islands" },
  hn: { id: "hn", name: "Honduras" },
  hr: { id: "hr", name: "Croatia" },
  ht: { id: "ht", name: "Haiti" },
  hu: { id: "hu", name: "Hungary" },
  ic: { id: "ic", name: "Canary Islands" },
  id: { id: "id", name: "Indonesia" },
  ie: { id: "ie", name: "Ireland" },
  il: { id: "il", name: "Israel" },
  im: { id: "im", name: "Isle of Man" },
  "in": { id: "in", name: "India" },
  io: { id: "io", name: "British Indian Ocean Territory" },
  iq: { id: "iq", name: "Iraq" },
  ir: { id: "ir", name: "Iran" },
  is: { id: "is", name: "Iceland" },
  it: { id: "it", name: "Italy" },
  je: { id: "je", name: "Jersey" },
  jm: { id: "jm", name: "Jamaica" },
  jo: { id: "jo", name: "Jordan" },
  jp: { id: "jp", name: "Japan" },
  ke: { id: "ke", name: "Kenya" },
  kg: { id: "kg", name: "Kyrgyzstan" },
  kh: { id: "kh", name: "Cambodia" },
  ki: { id: "ki", name: "Kiribati" },
  km: { id: "km", name: "Comoros" },
  kn: { id: "kn", name: "Saint Kitts and Nevis" },
  kp: { id: "kp", name: "North Korea" },
  kr: { id: "kr", name: "South Korea" },
  kw: { id: "kw", name: "Kuwait" },
  ky: { id: "ky", name: "Cayman Islands" },
  kz: { id: "kz", name: "Kazakhstan" },
  la: { id: "la", name: "Laos" },
  lb: { id: "lb", name: "Lebanon" },
  lc: { id: "lc", name: "Saint Lucia" },
  li: { id: "li", name: "Liechtenstein" },
  lk: { id: "lk", name: "Sri Lanka" },
  lr: { id: "lr", name: "Liberia" },
  ls: { id: "ls", name: "Lesotho" },
  lt: { id: "lt", name: "Lithuania" },
  lu: { id: "lu", name: "Luxembourg" },
  lv: { id: "lv", name: "Latvia" },
  ly: { id: "ly", name: "Libya" },
  ma: { id: "ma", name: "Morocco" },
  mc: { id: "mc", name: "Monaco" },
  md: { id: "md", name: "Moldova" },
  me: { id: "me", name: "Montenegro" },
  mf: { id: "mf", name: "Saint Martin" },
  mg: { id: "mg", name: "Madagascar" },
  mh: { id: "mh", name: "Marshall Islands" },
  mk: { id: "mk", name: "North Macedonia" },
  ml: { id: "ml", name: "Mali" },
  mm: { id: "mm", name: "Myanmar" },
  mn: { id: "mn", name: "Mongolia" },
  mo: { id: "mo", name: "Macau" },
  mp: { id: "mp", name: "Northern Mariana Islands" },
  mq: { id: "mq", name: "Martinique" },
  mr: { id: "mr", name: "Mauritania" },
  ms: { id: "ms", name: "Montserrat" },
  mt: { id: "mt", name: "Malta" },
  mu: { id: "mu", name: "Mauritius" },
  mv: { id: "mv", name: "Maldives" },
  mw: { id: "mw", name: "Malawi" },
  mx: { id: "mx", name: "Mexico" },
  my: { id: "my", name: "Malaysia" },
  mz: { id: "mz", name: "Mozambique" },
  na: { id: "na", name: "Namibia" },
  nc: { id: "nc", name: "New Caledonia" },
  ne: { id: "ne", name: "Niger" },
  nf: { id: "nf", name: "Norfolk Island" },
  ng: { id: "ng", name: "Nigeria" },
  ni: { id: "ni", name: "Nicaragua" },
  nl: { id: "nl", name: "Netherlands" },
  no: { id: "no", name: "Norway" },
  np: { id: "np", name: "Nepal" },
  nr: { id: "nr", name: "Nauru" },
  nu: { id: "nu", name: "Niue" },
  nz: { id: "nz", name: "New Zealand" },
  om: { id: "om", name: "Oman" },
  pa: { id: "pa", name: "Panama" },
  pe: { id: "pe", name: "Peru" },
  pf: { id: "pf", name: "French Polynesia" },
  pg: { id: "pg", name: "Papua New Guinea" },
  ph: { id: "ph", name: "Philippines" },
  pk: { id: "pk", name: "Pakistan" },
  pl: { id: "pl", name: "Poland" },
  pm: { id: "pm", name: "Saint Pierre & Miquelon" },
  pn: { id: "pn", name: "Pitcairn Islands" },
  pr: { id: "pr", name: "Puerto Rico" },
  ps: { id: "ps", name: "Palestine" },
  pt: { id: "pt", name: "Portugal" },
  pw: { id: "pw", name: "Palau" },
  py: { id: "py", name: "Paraguay" },
  qa: { id: "qa", name: "Qatar" },
  re: { id: "re", name: "Réunion" },
  ro: { id: "ro", name: "Romania" },
  rs: { id: "rs", name: "Serbia" },
  ru: { id: "ru", name: "Russia" },
  rw: { id: "rw", name: "Rwanda" },
  sa: { id: "sa", name: "Saudi Arabia" },
  sb: { id: "sb", name: "Solomon Islands" },
  sc: { id: "sc", name: "Seychelles" },
  sd: { id: "sd", name: "Sudan" },
  se: { id: "se", name: "Sweden" },
  sg: { id: "sg", name: "Singapore" },
  "sh-ac": { id: "sh-ac", name: "Ascension Island" },
  sh: { id: "sh", name: "Saint Helena" },
  si: { id: "si", name: "Slovenia" },
  sj: { id: "sj", name: "Svalbard & Jan Mayen" },
  sk: { id: "sk", name: "Slovakia" },
  sl: { id: "sl", name: "Sierra Leone" },
  sm: { id: "sm", name: "San Marino" },
  sn: { id: "sn", name: "Senegal" },
  so: { id: "so", name: "Somalia" },
  sr: { id: "sr", name: "Suriname" },
  ss: { id: "ss", name: "South Sudan" },
  st: { id: "st", name: "São Tomé & Príncipe" },
  sv: { id: "sv", name: "El Salvador" },
  sx: { id: "sx", name: "Sint Maarten" },
  sy: { id: "sy", name: "Syria" },
  sz: { id: "sz", name: "Eswatini" },
  ta: { id: "ta", name: "Tristan da Cunha" },
  tc: { id: "tc", name: "Turks & Caicos Islands" },
  td: { id: "td", name: "Chad" },
  tf: { id: "tf", name: "French Southern Territories" },
  tg: { id: "tg", name: "Togo" },
  th: { id: "th", name: "Thailand" },
  tj: { id: "tj", name: "Tajikistan" },
  tk: { id: "tk", name: "Tokelau" },
  tl: { id: "tl", name: "Timor-Leste" },
  tm: { id: "tm", name: "Turkmenistan" },
  tn: { id: "tn", name: "Tunisia" },
  to: { id: "to", name: "Tonga" },
  tr: { id: "tr", name: "Turkey" },
  tt: { id: "tt", name: "Trinidad & Tobago" },
  tv: { id: "tv", name: "Tuvalu" },
  tw: { id: "tw", name: "Taiwan" },
  tz: { id: "tz", name: "Tanzania" },
  ua: { id: "ua", name: "Ukraine" },
  ug: { id: "ug", name: "Uganda" },
  um: { id: "um", name: "U.S. Outlying Islands" },
  un: { id: "un", name: "United Nations" },
  us: { id: "us", name: "United States" },
  uy: { id: "uy", name: "Uruguay" },
  uz: { id: "uz", name: "Uzbekistan" },
  va: { id: "va", name: "Vatican City" },
  vc: { id: "vc", name: "Saint Vincent & Grenadines" },
  ve: { id: "ve", name: "Venezuela" },
  vg: { id: "vg", name: "British Virgin Islands" },
  vi: { id: "vi", name: "U.S. Virgin Islands" },
  vn: { id: "vn", name: "Vietnam" },
  vu: { id: "vu", name: "Vanuatu" },
  wf: { id: "wf", name: "Wallis & Futuna" },
  ws: { id: "ws", name: "Samoa" },
  xk: { id: "xk", name: "Kosovo" },
  ye: { id: "ye", name: "Yemen" },
  yt: { id: "yt", name: "Mayotte" },
  za: { id: "za", name: "South Africa" },
  zm: { id: "zm", name: "Zambia" },
  zw: { id: "zw", name: "Zimbabwe" },
  world: { id: "world", name: "World" },
  xx: { id: "xx", name: "Unknown" }
};
const UNKNOWN_COUNTRY_CODE = "xx";
function isCountryFlagCode(code) {
  return code in COUNTRIES;
}
export {
  COUNTRIES,
  UNKNOWN_COUNTRY_CODE,
  isCountryFlagCode
};
//# sourceMappingURL=countries.js.map
